module.exports = __webpack_public_path__ + "img/quality.04fd4d14.png";